export default __webpack_public_path__ + "static/polygon5-65c3b15a2996a443f02bab435fb8e387.png";